import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
// import 'rxjs/add/operator/map';
// import 'rxjs/add/operator/do';
// import 'rxjs/add/operator/catch';
import { IPagination } from '../_interfaces/pagination'
import { IAuftragsDokument } from '../_interfaces/auftrags-dokument';
// import { IChoiceList } from '../_interfaces/_choice-list';
// import * as moment from 'moment'; // DateTimeOffset-Fix
// import * as cloneDeep from 'lodash/cloneDeep'; // DateTimeOffset-Fix

//import { AppconfigService } from '../_services/appconfig.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, map,tap } from 'rxjs/operators';

import { CRUDBasicService, httpOptions } from '../_services/crud-basic.service';

@Injectable()
export class AuftragsDokumentService extends CRUDBasicService {

  //typeOf deprecated -> CRUDBasicService.propertyTypeOf
  /*typeOf(propertyName: string) {  // welchen Typs sind die Properties IN DER API ?
    let property = this.propertyTypes.find(f => f.name == propertyName);
    if(property != null) return property.type;
    else return null;    
  }*/
  propertyTypes = [ // welchen Typs sind die Properties IN DER API ?
    {name: 'id', type: 'int'},
    {name: 'createdBy', type: 'string'},
    {name: 'created', type: 'DateTimeOffset'},
    {name: 'modifiedBy', type: 'string'},
    {name: 'modified', type: 'DateTimeOffset'},
    {name: 'rowVersion', type: 'byte[]'},
    {name: 'dokument', type: 'byte[]'},
    {name: 'dateiname', type: 'String'},
    {name: 'dateiendung', type: 'string'},
    {name: 'bezeichnung', type: 'string'},
    {name: 'beschreibung', type: 'string'},
    {name: 'auftragsdatenId', type: 'int'},
    {name: 'summary', type: 'string'}
  ];

  private getDownloadDokumentURL(id: number): string {
    return this.apiBaseUrl + 'AuftragsDokumente/download/' + id;
  }

  private downloadDokumentToBlob(id: number): Observable<any> { // https://www.youtube.com/watch?v=tAIxMGUEMqE
    let httpOptionsForBinaryContent = new HttpHeaders({
      //'Content-Type': 'application/pdf', // nicht nötig
      //'Access-Control-Allow-Origin': '*', // nicht nötig
      //responseType : 'blob',  // siehe unten: direkt als Parm mitgegeben
      //Accept : 'application/pdf',
      Accept : 'application/*', // nicht nur PDF - auch Word!
      //observe : 'response'  // siehe unten: direkt als Parm mitgegeben
    });

    let url = this.getDownloadDokumentURL(id);
    return this.httpClient.get(url, { headers: httpOptionsForBinaryContent, observe: 'response', responseType: 'blob', withCredentials: true })
      .pipe(
        tap((response) => { 
          console.log("DokumenteService.downloadDokumentToBlob() response:", response);
          return response;
        }),
        catchError(this.handleError));
  }

  public downloadDokumentViaBlob(dokumentId, targetDSN: string /*(D)ownload, (S)ame Window, (N)ew Window*/) {
    console.log("AuftragsDokumentService.downloadDokumentViaBlob dokumentId:", dokumentId);
    this.downloadDokumentToBlob(dokumentId)
    .subscribe(
      response => {
        console.log("AuftragsDokumentService.downloadDokumentViaBlob response:", response);
        
        let filename = response.headers.get('content-disposition')?.split(';')[1].split('=')[1]; // erfordert API-seitig: .WithExposedHeaders("content-disposition")
        if(filename.startsWith('"')) filename = filename.substr(1);
        if(filename.endsWith('"')) filename = filename.substr(0, filename.length-1);
        console.log("AuftragsDokumentService.downloadDokumentViaBlob filename:", filename);
        let blob = response.body as Blob;
        
        switch(targetDSN) {
          case "D": // download
              let a = document.createElement('a');
              a.download = filename;    // wenn man das auslässt geht die PDF direkt auf, statt download
              a.href = window.URL.createObjectURL(blob);
              a.click();
              break;
          case "S": // open in SAME Window
              let a2 = document.createElement('a');
              //a2.download = filename;    // wenn man das auslässt geht die PDF direkt auf, statt download
              a2.href = window.URL.createObjectURL(blob);
              a2.click();
              break;
          case "N": // open in NEW Window
              let fileurl = window.URL.createObjectURL(blob);
              window.open(fileurl, "_blank");
              break;
          default: 
              break;
        }

        //Alternative von https://www.fachinformatiker.de/topic/152173-javascript-windowopenurl-mit-token-im-header/    -> öffnet neues Fenster
        //let file = new Blob([response.body],{type:'application/pdf'});
        //let fileurl = window.URL.createObjectURL(file);
        //window.open(fileurl, "_blank");
      },
      error => this.handleError(error)
    );
  }

  getAuftragsDokumenteCollection(pageNumber: number, pageSize: number, searchQuery: string): Observable<{ auftragsDokumente: IAuftragsDokument[], pagination: IPagination }> {
    return this.httpClient.get(this.apiBaseUrl + 'auftragsdokumente?pageNumber=' + pageNumber + '&pageSize=' + pageSize + '&searchQuery=' + searchQuery, { headers: httpOptions, observe: 'response', withCredentials: true })
      .pipe(
        map((response) => {
          return { auftragsDokumente: <IAuftragsDokument[]>response.body, pagination: <IPagination>JSON.parse(response.headers.get('x-pagination')) };
        }), catchError(this.handleError))
  }

  getAuftragsDokument(id: number): Observable<IAuftragsDokument> {

    if (id === 0) {
      // return Observable.create((observer: any) => {
      //   observer.next(this.initializeAuftragsDokument());
      //   observer.complete();
      // })
    }

    return this.httpClient.get<IAuftragsDokument>(this.apiBaseUrl + 'auftragsdokumente/' + id, { headers: httpOptions, observe: 'body', withCredentials: true })
      .pipe(map((response) => response), catchError(this.handleError));
  }



  
}